import { handleResponse, SERVER_HOST } from "@api";
import { TAddAddress, TAddress } from "@components/types";
import axios from "axios";

export const addAddress = async (addAddress: TAddress) => {
    let axiosMethod = addAddress.id == null ? axios.post : axios.put;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/addresses/${addAddress.id == null ? "" : addAddress.id}`,
        JSON.stringify(addAddress),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const getAllStates = async () => {
    const res = await fetch(`${SERVER_HOST}/api/v1/states/?skip=0&limit=100`)
    const result = await res.json()
    return result;
}

export const getCitiesOfState = async (name: string = null, stateId: number, limit?: number) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/cities/?${name != null && name?.length > 0 ? `name=${name}&` : ""}state_id=${stateId}${limit > 0 ? `&limit=${limit}` : ""}`)
    const result = await res.json()
    return result;
}

// States and a state's full city list barely change, so share one request per session between the
// address form and the location chooser. A failed request isn't cached.
let statesCache: Promise<any[]> | null = null;
export const getAllStatesCached = (): Promise<any[]> =>
    (statesCache ||= getAllStates().then((r) => (Array.isArray(r) ? r : [])).catch(() => { statesCache = null; return []; }));

const citiesCache = new Map<number, Promise<any[]>>();
export const getAllCitiesOfStateCached = (stateId: number): Promise<any[]> => {
    if (!citiesCache.has(stateId)) {
        citiesCache.set(stateId, getCitiesOfState(null, stateId, 2000)
            .then((r) => (Array.isArray(r) ? r : []))
            .catch(() => { citiesCache.delete(stateId); return []; }));
    }
    return citiesCache.get(stateId);
};

// Name search across every state (the address form's lookup is always scoped to one state)
export const searchCities = async (name: string, limit: number = 12) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/cities/?name=${encodeURIComponent(name)}&limit=${limit}`)
    const result = await res.json()
    return result;
}

export const getAddresses = async () => {
    if (localStorage.getItem("profile") !== null && localStorage.getItem("profile") !== undefined) {
        const res = await fetch(`${SERVER_HOST}/api/v1/addresses/?user_id=${JSON.parse(localStorage.getItem("profile"))?.id}`, {
            method: "GET",
            headers: { "Content-Type": "application/json;charset=utf-8", "Authorization": `Bearer ${localStorage.getItem("token")}` },
            body: JSON.stringify(addAddress)
        })
        const result: TAddress[] = await res.json()
        return result;
    }

}

export const removeAddress = async (id: number) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/addresses/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json;charset=utf-8", "Authorization": `Bearer ${localStorage.getItem("token")}` },
    })
    const result = await res.json()
    return result;
}

export const getAddressById = async (id: number) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`/api/v1/addresses/${id}`)
    return handleResponse(res);
}